export const PATHS = {
  REPORTING: "/reporting",
  REPORTING_ACADEMIES_DASHBOARD: "/reporting/academies-dashboard",
  REPORTING_BENCHMARK: "/reporting/benchmark",
  REPORTING_SKILL_CLOUD: "/reporting/skill-cloud",
};
  
export default PATHS;